import { DeepPartial } from 'utility-types';
import {
  Record,
  String as RTString,
  Array as RTArray,
  Number as RTNumber,
  Undefined,
  Static
} from 'runtypes';
import { PrimaryCustomer } from '../customer';
import { ExistingAccount, Investment } from '../investment';
import { Custodian } from '../custodian';

const RolloverApplication = {
  customer: PrimaryCustomer,
  termsIDs: RTArray(RTString),
  existingAccounts: RTArray(ExistingAccount)
    .Or(RTArray(Record({})))
    .Or(Undefined),
  newInvestments: RTArray(Investment),
  profileApplicationID: RTString,
  formerEmployerName: RTString.Or(Undefined),
  rolloverSubType: RTString.Or(Undefined),
  estimatedRolloverAmount: RTNumber,
  investmentMethod: RTString,
  rolloverType: RTString,
  deviceToken: RTString
};

export const DirectRolloverApplication = Record({
  ...RolloverApplication,
  custodian: Custodian
});

export const IndirectRolloverApplication = Record({
  ...RolloverApplication
});

export type StaticDirectRolloverApplication = Static<
  typeof DirectRolloverApplication
>;
export type OptionalDirectRolloverApplication = DeepPartial<
  StaticDirectRolloverApplication
>;

export type StaticIndirectRolloverApplication = Static<
  typeof IndirectRolloverApplication
>;
export type OptionalIndirectRolloverApplication = DeepPartial<
  StaticIndirectRolloverApplication
>;
